export enum ECopyTradeRisk {
  UNSUITABLE = 'Unsuitable',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High'
}

export enum ECopyTradeFilter {
  EARLIER_COPIED = 'EarlierCopied',
  ALL = 'All',
  SPOTLIGHT = 'Spotlight',
  GLOBAL_SIGNALS = 'GlobalSignals',
  MAX_DRAWDOWN = 'MaxDrawdown',
  TOP_FREE_SIGNALS = 'TopFreeSignals',
  TOP_PAID_SIGNALS = 'TopPaidSignals',
  NEW_SIGNAL_PROVIDERS = 'NewSignalProviders',
  HIGH_RISK = 'HighRisk',
  MEDIUM_RISK = 'MediumRisk',
  LOW_RISK = 'LowRisk',
  FAVOURITE_SIGNALS = 'FavouriteSignals',
  STRATEGIES = 'Strategies',
  COPIERS_PROFIT_YEAR = 'CopiersProfitYear',
  COPIERS_PROFIT_MONTH = 'CopiersProfitMonth',
  COPIERS_BALANCE = 'CopiersBalance',
  DEFAULT = 'Default'
}

export const COPY_TRADE_FILTERS_TABS = [
  ECopyTradeFilter.EARLIER_COPIED,
  ECopyTradeFilter.ALL,
  ECopyTradeFilter.SPOTLIGHT,
  ECopyTradeFilter.GLOBAL_SIGNALS,
  ECopyTradeFilter.MAX_DRAWDOWN,
  ECopyTradeFilter.TOP_FREE_SIGNALS,
  ECopyTradeFilter.NEW_SIGNAL_PROVIDERS,
  ECopyTradeFilter.HIGH_RISK,
  ECopyTradeFilter.MEDIUM_RISK,
  ECopyTradeFilter.LOW_RISK,
  ECopyTradeFilter.FAVOURITE_SIGNALS,
  ECopyTradeFilter.STRATEGIES,
  ECopyTradeFilter.COPIERS_PROFIT_YEAR,
  ECopyTradeFilter.COPIERS_PROFIT_MONTH,
  ECopyTradeFilter.COPIERS_BALANCE
];

export enum ESectionPreferenceStrategyType {
  STRATEGY_PROFILE = 'STRATEGY_PROFILE',
  RETURN_HISTORY_CHART = 'RETURN_HISTORY_CHART',
  OPEN_POSITIONS = 'OPEN_POSITIONS',
  HISTORY = 'HISTORY'
}

export const POSSIBLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export enum ECopyTradeSessionKeys {
  ACTION = 'ACTION',
  VERIFIER = 'VERIFIER',
  STATE = 'STATE',
  SIGN_UP_STATE_VERIFIER = 'SIGN_UP_STATE_VERIFIER'
}

export const COPY_TRADE_OAUTH_SUCCESS_MESSAGE = 'oauth_success';
export const COPY_TRADE_OAUTH_ERROR_MESSAGE = 'oauth_error';

export enum ECopyTradeAuthAction {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP'
}

export const PELICAN_COPY_TRADE_FORGOT_PASSWORD_URL = 'https://identity.copy-trade.io/Identity/Account/ForgotPassword';
export const PELICAN_COPY_TRADE_PROFITABILITY_URL =
  'https://knowledgebase.pelicantrading.io/en/faqs-for-using-the-app#profile-stats';
export const PELICAN_COPY_TRADE_COPIER_DRAWDOWN_URL =
  'https://knowledgebase.pelicantrading.io/how-do-you-set-up-a-maximum-drawdown';
export const PELICAN_COPY_TRADE_STAST_URL = 'https://docs.pelicantrading.io/items/stastlongform.pdf';
export const PELICAN_COPY_TRADE_PERFORMANCE_FEE_URL =
  'https://knowledgebase.pelicantrading.io/what-is-a-performance-fee';
export const PELICAN_COPY_TRADE_TRADE_SIZE_URL =
  'https://knowledgebase.pelicantrading.io/en/what-copy-trade-size-settings-can-i-choose';
export const PELICAN_COPY_TRADE_COPIER_AGREEMENT_URL =
  'https://docs.pelicantrading.io/items/pelican_copier_agreement.pdf';
export const PELICAN_COPY_TRADE_COPIER_AUTHORISATION_URL =
  'https://docs.pelicantrading.io/items/pelican_copier_authorisation_terms.pdf';
export const PELICAN_COPY_TRADE_SIGNAL_DRAWDOWN_URL =
  'https://docs.pelicantrading.io/items/drawdown_subscription_performance_fee_terms.pdf';

export const PELICAN_COPY_TRADE_PROVIDER = 'Pelican';
export const PELICAN_COPY_TRADE_STRATEGY_LIST_CHUNK_SIZE_FREE = 10;
export const PELICAN_COPY_TRADE_STRATEGY_LIST_MOBILE_CHUNK_SIZE_FREE = 10;
export const PELICAN_COPY_TRADE_STRATEGY_LIST_CHUNK_SIZE = 20;
export const PELICAN_COPY_TRADE_STRATEGY_SEARCH_DEBOUNCE = 1000;
export const PELICAN_COPY_TRADE_MAX_SEARCH_HISTORY = 10;
export const PELICAN_COPY_TRADE_SEARCH_TAG_MAX_WIDTH = 240;
export const PELICAN_COPY_TRADE_FREEMIUM_VISIBLE_LIMIT = 5;

export const PELICAN_COPY_TRADE_HEADER_HEIGHT_IN_PX = 133;
export const PELICAN_COPY_TRADE_HEADER_BORDER_HEIGHT_IN_PX = 3;

export enum ECopyTradeTradeSizeType {
  FIXED = 'Fixed',
  MIRROR_SIZE = 'MirrorSize',
  MIRROR_RISK_BY_EQUITY = 'MirrorRiskByEquity',
  MIRROR_RISK_BY_BALANCE = 'MirrorRiskByBalance'
}

export enum ECopyTradeStopCopySettingsMode {
  MIRROR = 'Mirror',
  CLOSE = 'Close',
  MANUAL = 'Manual'
}

export const COPY_TRADE_SELECTED_COPIER_ID_KEY = 'copytrade_selected_copier_id';

export const COPIER_DRAWDOWN_LEVEL_STEP = 0.01;
export const COPIER_DRAWDOWN_LEVEL_MIN = 0;

export const COPIER_DRAWDOWN_DISCLAIMER_ITEMS = [
  'Drawdown protections are not guaranteed',
  'Regularly reviewing your trading activity is critical to manage your risk',
  'Excessive risk (trade size) may result in drawdown protection levels being missed'
] as const;

export enum EPrecheckLoadingType {
  COPY = 'COPY',
  EDIT = 'EDIT',
  STOP = 'STOP',
  DRAWDOWN = 'DRAWDOWN'
}

export enum EMissedTradeReason {
  TRADE_EXPIRED = 'TradeExpired',
  EXCEEDED_SOFT_STOP_LIMIT = 'ExceededSoftStopLimit',
  INSUFFICIENT_FUNDS = 'InsufficientFunds',
  EXCEEDED_HARD_STOP_LIMIT = 'ExceededHardStopLimit',
  DUE_TO_BROKER_ERROR = 'DueToBrokerError',
  MINIMUM_EQUITY_NOT_MET = 'MinimumEquityNotMet'
}

export enum ECopyTradeTimeframe {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

export const COPY_TRADE_RESPONSE_TYPE = 'code';
export const COPY_TRADE_CODE_CHALLENGE_METHOD = 'S256';

// Login
export const COPY_TRADE_BASE_URL = 'https://identity.copy-trade.io/connect/authorize';
export const COPY_TRADE_CALLBACK_PATH = '/sso/pelican/authenticated';
export const COPY_TRADE_SCOPE = 'openid profile email copytrade offline_access';

// Sign Up
export const COPY_TRADE_SIGN_UP_BASE_URL = 'https://identity.copy-trade.io/Identity/Account/Register';
export const COPY_TRADE_SIGN_UP_RETURN_URL = '/connect/authorize/callback?';
export const COPY_TRADE_SIGN_UP_SCOPE = 'openid profile email address pelicanapi broker copytrade offline_access';

export const COPY_TRADE_POP_UP_CLOSE_DELAY_MS = 3000;
export const COPY_TRADE_MAX_TRADE_SIZE_VALUE_FIXED = 100;
export const COPY_TRADE_MAX_TRADE_SIZE_VALUE = 10;
export const COPY_TRADE_MIN_TRADE_SIZE_VALUE_PROPORTIONAL = 0.1;
